<div class="ticket-list-item-container" (click)="goToTicket()">
  <div class="ticket-data">
    {{ ticket.subject }}<br />
    <span class="sub-data">
      {{ ('general.created' | translate) + ': ' + ticket.created_at_pretty }}<br />
      {{ ('general.updated' | translate) + ': ' + ticket.updated_at_pretty }}
    </span>
  </div>
  <fa-icon icon="chevron-right" class="chevron"></fa-icon>
</div>